import { Badge, Button, Col, Form, Select, Space, Tag } from "antd";
import { UserInfoContext } from "Context/CommonContext";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LectureChapterArr } from "utilFunctions/Constants/Constants";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import DatePickerAntdComponent from "utilFunctions/shared/AntdSharedComponents/DatePickerAntdComponent";
import DrawerAntdComponent from "utilFunctions/shared/AntdSharedComponents/DrawerAntdComponent";
import HeadersComponent from "utilFunctions/shared/AntdSharedComponents/HeadersComponent";

const statuses: any = [
  {
    label: "Unmarked",
    value: "Unmarked",
  },
  {
    label: "Marked",
    value: "Marked",
  },
];
interface FacultyBatchHeaderIF {
  filterState: any;
  setFilterState: any;
  applyFilter: any;
  open: boolean;
  setOpen: any;
  onSelectedChange: any;
  selectedType: any;
  selectedTabIndex: any;
  facultyDetail: any;
  subjects?: any;
  filterListing?: any;
  setFilterStateLectureStatus?: any;
  startDate?: any;
  endDate?: any;
  dateRanges?: any;
  setDateRanges?: any;
  BATCHData?: any;
}
const FacultyBatchHeader = ({
  filterState,
  applyFilter,
  open,
  setOpen,
  onSelectedChange,
  selectedType,
  selectedTabIndex,
  facultyDetail,
  filterListing,
  startDate,
  endDate,
  dateRanges,
  setDateRanges,
  BATCHData,
}: FacultyBatchHeaderIF) => {
  const navigate = useNavigate();
  const [isFilterApplied, setIsFilterApplied] = useState<any>(false);
  const { screen }: any = useWindowSize();
  const location = useLocation();
  const { state } = location;
  const userInfo = useContext<any>(UserInfoContext);
  const subjects: any = userInfo.subjectsListing;
  const [obj, setObj] = useState({
    startDate: moment(dateRanges[0].startDate).format("YYYY-MM-DD"),
    endDate: moment(dateRanges[0].endDate).format("YYYY-MM-DD"),
  });
  const batchDataOptions = BATCHData.map((el: any) => ({
    label: el?.batchName,
    value: el?.batchId,
  }));
  const filterheadingListing: any = [
    {
      name: "Batch",
      nickName: "batchIds",
      data: batchDataOptions,
      singleSelect: true,
      filterSelectedData: [],
    },
    {
      name: "Subject",
      nickName: "subject",
      data: subjects,
      singleSelect: true,
      filterSelectedData: [],
    },
    {
      name: "Syllabus Compliance Status",
      nickName: "status",
      data: statuses,
      singleSelect: true,
      filterSelectedData: [],
    },
    {
      name: "Attendance Status",
      nickName: "attendanceStatus",
      data: statuses,
      singleSelect: true,
      filterSelectedData: [],
    },
    {
      name: "Date Range",
      nickName: "dateRange",
      data: null,
      singleSelect: false,
      filterSelectedData: [],
    },
  ];
  useEffect(() => {
    if (dateRanges) {
      setObj({
        startDate: moment(dateRanges[0].startDate).format("YYYY-MM-DD"),
        endDate: moment(dateRanges[0].endDate).format("YYYY-MM-DD"),
      });
    }
  }, [dateRanges]);
  const backButtonHandler = () => {
    const branchId =
      state && state.selectedBatch !== undefined ? state.selectedBatch : null;
    navigate("/admin/faculties/branch/" + branchId, {
      replace: true,
      state: {
        selectedStudent: null,
        selectedBatch: branchId,
        selectedState:
          state && state.selectedState !== undefined
            ? state.selectedState
            : null,
        selectedRegion:
          state && state.selectedRegion !== undefined
            ? state.selectedRegion
            : null,
      },
    });
  };
  const newFilterState = JSON.parse(JSON.stringify(filterState));
  const chipsFields = newFilterState && newFilterState.chipFields;
  delete newFilterState["chipFields"];
  const filterLength = Object.values(newFilterState).filter(
    (ele) => ele != null
  ).length;
  const [chipFields, setChipFields] = useState<any>({});
  const resetHandler = () => {
    if (selectedTabIndex == "1") {
      const val = LectureChapterArr.find(
        (ele: any) => ele.value === "plannedLectures"
      )?.value;
      applyFilter(val);
      onSelectedChange(val);
      setIsFilterApplied(false);
    } else {
      const obj = {
        batchIds: null,
        dateRange:
          moment(startDate).format("YYYY-MM-DD") +
          "~" +
          moment(endDate).format("YYYY-MM-DD"),
        subject: null,
        attendanceStatus: null,
        status: null,
      };
      applyFilter(obj);
      setChipFields(obj);
      setIsFilterApplied(false);
    }
  };
  const returnDate = (date: any) => {
    return date?.[0].format("MMM-YYYY") + " ~ " + date?.[1].format("MMM-YYYY");
  };
  const returnDateRange = (date: any) => {
    const [date1, date2] = date.split("~");
    return (
      moment(date1).format("DD-MMM-YY") +
      " ~ " +
      moment(date2).format("DD-MMM-YY")
    );
  };
  const handleAddFilterArrayList = (name: any, val: any) => {
    if (name == "subject") {
      val = subjects.find((el: any) => el.value == val)["label"];
    }
    setChipFields((prevChipField: any) => ({
      ...prevChipField,
      [name]: val,
    }));
  };
  const returnFilter = (ele: any) => {
    if (filterListing.includes(ele.nickName)) {
      if (ele.singleSelect) {
        return (
          <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
            <Form.Item label={ele.name}>
              <Select
                placeholder={ele.name}
                style={{ width: "100%" }}
                size="large"
                options={ele.data}
                value={
                  chipFields[ele.nickName] ? chipFields[ele.nickName] : null
                }
                onChange={(selected: any) => {
                  handleAddFilterArrayList(ele.nickName, selected);
                }}
              />
            </Form.Item>
          </Col>
        );
      } else if (ele.nickName == "dateRange") {
        return (
          <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
            <Form.Item label={ele.name}>
              <DatePickerAntdComponent
                dateRanges={obj}
                dateSetHandler={(obj: any) => {
                  setDateRanges([
                    {
                      startDate: obj.startDate,
                      endDate: obj.endDate,
                      key: "selection",
                    },
                  ]);
                  setChipFields({
                    ...chipFields,
                    dateRange: obj.startDate + "~" + obj.endDate,
                  });
                }}
              ></DatePickerAntdComponent>
            </Form.Item>
          </Col>
        );
      }
    } else {
      return null;
    }
  };

  const filterFormComponent = (tabindex: any) => {
    return tabindex == "1" ? (
      <Form layout={"vertical"} className="w-100">
        <Form.Item label="Stream">
          <Select
            showSearch
            value={selectedType}
            style={{ width: "100%" }}
            size="large"
            options={LectureChapterArr}
            onChange={(selected: any) => {
              onSelectedChange(selected);
            }}
          />
        </Form.Item>
      </Form>
    ) : (
      <Form layout={"vertical"} className="w-100">
        {filterheadingListing.map((ele: any) => returnFilter(ele))}
      </Form>
    );
  };
  const applyFiltersforLectureStatus = (chipField: any) => {
    applyFilter(chipField);
    setOpen(false);
  };

  const returnBatchName = (options: any, item: any) => {
    const dataData = options.find((el: any) => el.value == item);
    return dataData ? dataData["label"] : "";
  };

  const Reset = () => <Button onClick={resetHandler}>Reset</Button>;
  return (
    <>
      <DrawerAntdComponent
        title={"Filters"}
        open={open}
        setOpen={setOpen}
        width={450}
        footer={
          <>
            <Space className="d-flex justify-content-end">
              <Button
                type="primary"
                onClick={() => {
                  if (selectedTabIndex == "1") {
                    setIsFilterApplied(true);
                    applyFilter(selectedType);
                  } else {
                    setIsFilterApplied(true);
                    applyFiltersforLectureStatus(chipFields);
                  }
                }}
                className={"m-0"}
              >
                Apply
              </Button>
              {isFilterApplied ? <Reset /> : null}
              <Button onClick={() => setOpen(false)}>Close</Button>
            </Space>
          </>
        }
      >
        {filterFormComponent(selectedTabIndex)}
      </DrawerAntdComponent>
      <HeadersComponent
        cardTitle={facultyDetail?.name + " | " + facultyDetail?.employeeId}
        backButtonHandler={backButtonHandler}
      >
        <Space>
          {["1", "3"].includes(selectedTabIndex) &&
            filterLength > 0 &&
            ["xxl", "xl", "lg"].includes(screen) && (
              <>
                {filterState.chipFields &&
                  Object.keys(filterState.chipFields).map((ele: any) => {
                    return (
                      chipsFields[ele] != null && (
                        <Tag
                          style={{
                            textAlign: "center",
                            textTransform: "capitalize",
                          }}
                          key={ele}
                        >
                          {ele === "batchIds"
                            ? returnBatchName(
                                batchDataOptions,
                                chipsFields[ele]
                              )
                            : typeof chipsFields[ele] != "object"
                            ? ele === "dateRange"
                              ? returnDateRange(chipsFields[ele])
                              : chipsFields[ele]
                            : ele === "yearMonth"
                            ? returnDate(filterState[ele])
                            : ele === "dateRange"
                            ? returnDate(filterState[ele])
                            : filterState[ele]["label"]}
                        </Tag>
                      )
                    );
                  })}
              </>
            )}
          {["1", "3"].includes(selectedTabIndex) && (
            <Badge count={filterLength ? filterLength : 0}>
              <Button
                type="primary"
                onClick={() => {
                  setOpen(true);
                }}
              >
                Filters
              </Button>
            </Badge>
          )}
          {isFilterApplied ? <Reset /> : null}
        </Space>
      </HeadersComponent>
    </>
  );
};

export default FacultyBatchHeader;
